export const tinyCfg = {
    menubar: false,
    paste_as_text: true,
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
    ],
    toolbar: 'undo redo | formatselect | ' +
        'bold italic underline strikethrough backcolor | bullist numlist | ' +
        'code removeformat',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
}
